import { properties } from "@repoflow/common/schema-fields";

const { createdAt,
  updatedAt } = properties

export {
  createdAt,
  updatedAt
}

export const orgId = {
  type: "string"
};
export const pageId = {
  label: "PageId",
  type: "string"
};

export const title = {
  label: "Title",
  type: "string",
  minLength: 1
};

// Descriptive, not an identifier. The table is keyed (orgId, pageId) and
// DynamoDB has no secondary uniqueness, so enforcing one slug per org would
// mean either a second table or a conditional write against a lookup row.
// Neither is worth it until something actually resolves a page by slug.
export const slug = {
  label: "Slug",
  type: "string",
  default: "",
};

export const body = {
  label: "Body",
  type: "string",
  default: "",
};

export const status = {
  type: "string",
};
